import { signal } from "@preact/signals-react";

import StepMoney from "./StepMoney";
import { layout as layoutMoney } from "./ModelMoney";
import { useWizard } from "storev2/wizardStore";
import proxy from "api/proxy";
import funcs from "tools/functions";
import { useTable } from "storev2/tableStore";

const MONEY = [
  100000, 50000, 20000, 10000, 5000, 2000, 1000, 500, 200, 100, 50,
];

function getDefaults() {
  const layout = layoutMoney();
  const { setTable } = useTable.getState();
  const rows = new Map();
  for (const value of MONEY) {
    rows.set(value, {
      id: value,
      bill: value,
      quantity: 0,
    });
  }
  const res = {
    total: signal(0),
    money: new Map(rows),
    start_balance: 0,
  };
  setTable({ layout, records: res.money });
  return res;
}

const model = "account.statement";

async function onAcceptClose() {
  const terminal = funcs.getCookie();
  const { store } = useWizard.getState();
  let next = "success";
  let msgError;
  const method = "do_close_statement";
  const money = [];
  if (store.money) {
    for (const rec of store.money.values()) {
      money.push([rec.id, rec.quantity]);
    }
  }

  const args = [
    {
      money: money,
      data: money,
      device: terminal.device_id,
    },
  ];
  const { error } = await proxy.methodCall({ model, method, args });
  if (error) {
    next = "error";
    msgError = error.error;
  }
  return { next, msgError };
}

function handleClose() {}

const closeBtn = { name: "close", handleClick: handleClose };

const closeStatementViews = {
  start: {
    label: "close_start",
    Component: StepMoney,
    buttons: [closeBtn, { name: "ok", handleClick: onAcceptClose }],
    initialStore: getDefaults,
  },
  success: {
    label: "close_success",
    msg: "account.statement.close.msg_success",
    buttons: [closeBtn],
  },
  error: {
    key: "close_error",
    buttons: [closeBtn],
  },
};

export { closeStatementViews };
